import { atom, useAtom } from 'jotai';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const vehicleDefault = undefined;

export const vehicle = atom(vehicleDefault);

const updateVehicle = atom(null, (get, set, slug) => {
  const current = get(vehicle);

  if (current === slug) {
    return;
  }

  set(vehicle, slug);
});

export const categoryDefault = {
  category: undefined,
  subCategory: undefined,
};

export const caterogy = atom(categoryDefault);

const updateCategory = atom(null, (get, set, { category, subCategory }) => {
  const current = get(caterogy);

  if (
    current.category === category &&
    current.subCategory === current.subCategory
  ) {
    return;
  }

  set(caterogy, { category, subCategory });
});

export const useUpdateSelection = ({ category, vehicle: slug }) => {
  const [, updateSlug] = useAtom(updateVehicle);
  const [, updateCat] = useAtom(updateCategory);

  useEffect(() => {
    if (category) {
      updateCat(category);
    }

    if (slug) {
      updateSlug(slug);
    }
  }, [category, slug]);
};

export const isCatalogueMenuOpenAtom = atom<boolean>(false);
export const isCatMenuSelecionOpenAtom = atom<boolean>(false);
export const currentSelectionAtom = atom<
  { category: any; subCategory: any; index?: number } | undefined
>(undefined);
export const selectedCatalogueSelectionAtom = atom<{
  category: Partial<TCategory>;
  part: TPart;
} | null>(null);
export const actualStepAtom = atom<0 | 1 | undefined>(undefined);
export const catalogueGroupsAtom = atom<TCategories>([] as TCategories);

export const viewSelection = atom<'DESKTOP' | 'MOBILE' | undefined>(undefined);

export const selectedTabStepAtom = atom<0 | 1 | 2 | undefined>(undefined);
